import { Breadcrumb } from "antd";
import React from "react";
import { ChevronRightIcon } from "../assets/icons/icons";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ items }) => {
  return (
    <Breadcrumb
      className="zl-custom-breadcrumbs"
      separator={
        <ChevronRightIcon
          fill="#AFAFAF"
          width={16}
          height={15}
          className="breadcrumb-icon"
        />
      }
    >
      {items.map((item, index) => (
    <Breadcrumb.Item key={index}>
      {item.href ? <Link to={item.href} state={item.state ?? undefined}>{item.title}</Link> : item.title}
    </Breadcrumb.Item>
  ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
